import { render, staticRenderFns } from "./MarketPictureComponent.vue?vue&type=template&id=39478d71&scoped=true&lang=pug&"
import script from "./MarketPictureComponent.vue?vue&type=script&lang=js&"
export * from "./MarketPictureComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketPictureComponent.vue?vue&type=style&index=0&id=39478d71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39478d71",
  null
  
)

export default component.exports